import { Page } from '../widget/WidgetIllustrations';
import art from '../widget/WidgetIllustrations.module.css';
import styles from './WhatsNewArt.module.css';

/**
 * The drawing beside What's new (TOADO-859): the release's headline, a page
 * with pins dropped on it as a walkthrough records, in the app's own colours
 * so it reads on either theme. Decoration only: the list beside it says the
 * same, so it is hidden from screen readers. The pins drop in once; under
 * reduced motion they are simply there.
 */
export function WhatsNewArt() {
  const pins: Array<[number, number, number]> = [[46, 40, 1], [96, 52, 2], [70, 74, 3]];
  return (
    <svg className={`${art.art} ${styles.art}`} viewBox="0 0 160 112" aria-hidden="true" focusable="false" data-testid="whats-new-art">
      <Page width={160} height={112} />
      <rect className={art.ink} x={10} y={32} width={58} height={5} rx={2.5} />
      <rect className={art.faint} x={10} y={42} width={84} height={3} rx={1.5} />
      <rect className={art.faint} x={10} y={48} width={70} height={3} rx={1.5} />
      <rect className={art.block} x={10} y={57} width={50} height={16} rx={3} />
      <rect className={art.block} x={66} y={57} width={50} height={16} rx={3} />
      <rect className={art.faint} x={10} y={79} width={96} height={3} rx={1.5} />
      {pins.map(([x, y, n], index) => (
        <g key={n} className={styles.pin} style={{ animationDelay: `${index * 180}ms` }}>
          <path className={art.accent} d={`M${x} ${y + 9} C ${x - 6} ${y + 3}, ${x - 6} ${y - 3}, ${x} ${y - 4} C ${x + 6} ${y - 3}, ${x + 6} ${y + 3}, ${x} ${y + 9} Z`} />
          <text className={art.pinText} x={x} y={y + 2.4} textAnchor="middle">{n}</text>
        </g>
      ))}
      {/* The walkthrough recording them. */}
      <rect className={art.recBadge} x={10} y={92} width={140} height={13} rx={6.5} />
      <circle className={`${art.recDot} ${styles.rec}`} cx={19} cy={98.5} r={3} />
      <rect className={art.track} x={28} y={97} width={114} height={3} rx={1.5} />
      <rect className={`${art.progress} ${styles.progress}`} x={28} y={97} width={78} height={3} rx={1.5} />
    </svg>
  );
}
